<template>
  <v-select
    v-model="visibleColumns"
    :items="columns"
    @update:model-value="emitUpdateVisibleColumns"
    multiple
    item-title="title"
    item-value="value"
    variant="outlined"
    hide-details
    color="primary"
    placeholder="Select columns"
    return-object
    class="max-width-300"
    density="compact">
    <template #prepend-item>
      <div class="d-flex gap-4 ma-4 mt-2">
        <v-btn
          @click="toggleDefault"
          variant="outlined"
          density="comfortable"
          size="small"
          prepend-icon="mdi-view-column">
          {{ t('global.basicTerms.default') }}
        </v-btn>
        <v-btn
          @click="togglePreset('asset')"
          variant="outlined"
          density="comfortable"
          size="small"
          prepend-icon="mdi-truck-trailer">
          {{ t('global.specialtyTerms.assets') }}
        </v-btn>
        <v-btn
          @click="togglePreset('carrier')"
          variant="outlined"
          density="comfortable"
          size="small"
          prepend-icon="mdi-truck">
          {{ t('global.specialtyTerms.carriers') }}
        </v-btn>
        <v-btn @click="toggleAll" variant="outlined" density="comfortable" size="small">
          {{ t('global.phrases.allFields') }}
        </v-btn>
      </div>
      <v-divider />
    </template>

    <template #chip="{ item, index }">
      <span v-if="index === 0">
        {{ t('global.phrases.selectedColumns') }} ({{ visibleColumns.length }})
      </span>
    </template>
  </v-select>
</template>
<script>
import { defineComponent, ref, watch, onMounted } from 'vue';
import useYard from '@/modules/yard/composables/useYard';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewListViewColumnSelect',
  emits: ['update:visibleColumns'],
  props: {
    /*
     * Each item expects to be an object with
       - default: visible by default
       - title: column label
       - key: data property
       - category: carrier or asset
     */
    columns: {
      type: Array,
      required: true
    }
  },
  setup(props, { emit }) {
    const yardStore = useYard();
    const { t } = useI18n();
    const visibleColumns = ref([]);

    const emitUpdateVisibleColumns = value => emit('update:visibleColumns', value);

    const togglePreset = preset =>
      (visibleColumns.value = props.columns.filter(c => !c.category || c.category === preset));
    const toggleAll = () => (visibleColumns.value = [...props.columns]);
    const toggleDefault = () => (visibleColumns.value = props.columns.filter(c => c.default));

    watch(
      visibleColumns,
      value => {
        emitUpdateVisibleColumns(value);
      },
      { immediate: false, deep: true }
    );

    const setDefaultColumns = async () => {
      let columns = props.columns.filter(c => c.default);

      const previousData = await yardStore.fetchPreviousYardData();
      if (previousData?.listViewColumns) {
        columns = props.columns.filter(column => previousData.listViewColumns.includes(column.key));
      }

      visibleColumns.value = columns;
      emitUpdateVisibleColumns(columns);
    };

    onMounted(() => setDefaultColumns());

    return {
      visibleColumns,
      toggleAll,
      togglePreset,
      toggleDefault,
      emitUpdateVisibleColumns,
      t
    };
  }
});
</script>
